import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 8,
		y: .477615,
		width: 10.6383,
		height: 10.6383,
		rx: 2.5,
		transform: "rotate(45 8 0.477615)",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.4933 7.06733L9.24898 7.05717C9.22494 6.896 9.17737 6.75264 9.10628 6.62707C9.03517 6.49961 8.94433 6.39092 8.83376 6.30101C8.72319 6.2111 8.59574 6.14189 8.45142 6.09337C8.30899 6.04486 8.15445 6.01993 7.98779 6.01856C7.68666 6.01611 7.42497 6.08877 7.20271 6.23656C6.98044 6.38246 6.80891 6.59695 6.68813 6.88002C6.56733 7.16121 6.50858 7.50349 6.51188 7.90689C6.51526 8.32165 6.57966 8.67063 6.70507 8.95382C6.83237 9.23703 7.00834 9.45151 7.233 9.59727C7.45765 9.74303 7.71675 9.81711 8.0103 9.8195C8.17507 9.82085 8.32735 9.80031 8.46714 9.7579C8.60882 9.7155 8.73425 9.65308 8.84341 9.57065C8.95256 9.48632 9.04262 9.38385 9.1136 9.26323C9.18647 9.14262 9.23648 9.00479 9.26362 8.84972L10.5079 8.86556C10.4779 9.13234 10.3995 9.38925 10.2728 9.6363C10.1479 9.88146 9.97831 10.1007 9.764 10.294C9.55157 10.4854 9.29715 10.6367 9.00074 10.748C8.70621 10.8573 8.37239 10.9104 7.9993 10.9074C7.48038 10.9031 7.01542 10.7819 6.60442 10.5437C6.19532 10.3056 5.87059 9.963 5.63022 9.51601C5.39174 9.06903 5.26992 8.52926 5.26476 7.89671C5.25958 7.26226 5.37449 6.72348 5.60948 6.28037C5.84447 5.83725 6.16556 5.50089 6.57273 5.27129C6.97989 5.03979 7.43915 4.92612 7.95049 4.9303C8.2876 4.93305 8.60048 4.98295 8.88912 5.08C9.17966 5.17706 9.43741 5.3174 9.66237 5.50104C9.88732 5.68278 10.0709 5.90491 10.2132 6.16741C10.3574 6.42992 10.4507 6.72989 10.4933 7.06733Z",
		fill: "currentColor"
	})]
});
export default SvgClass;
